import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

export default function DiscussionApproval({ ownerGroup, events }) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussionApproval"
      values={{
        name: util.getEventNames(events),
        group: ownerGroup?.name || "Deleted",
      }}
      components={{ b: <b />, formattedComment: <FormattedComment noLink /> }}
    />
  );
}
